import { Component, Input, OnInit } from '@angular/core';
import { Prize, PrizeType } from 'src/app/data/schema/prize';
import { RaffleService } from 'src/app/data/service/raffle.service';
import { RaffleBasePage } from '../../raffle-base-page';
import { AuthenticationService } from 'src/app/core/modules/auth-core/data/service/authentication.service';
import { PrizeValidationHelper } from 'src/app/core/helper/prize-validation.helper';

@Component({
  selector: 'app-prize-card',
  templateUrl: './prize-card.component.html',
  styleUrls: ['./prize-card.component.scss'],
})
export class PrizeCardComponent extends RaffleBasePage implements OnInit {

  @Input() prize: Prize;
  @Input() active = false;
  @Input() reorderMode = false;

  isEarlyBird = false;

  get prizeType() { return PrizeType; }

  constructor(
    raffleService: RaffleService,
    authService: AuthenticationService,
  ) {
    super(raffleService, authService);
  }

  ngOnInit() {
    this.isEarlyBird = PrizeValidationHelper.isEarlyBird(this.prize, this.raffle);
  }
}
